import { GlobalMessages } from '@shared/localization/messages';
import type { ReactNode } from 'react';

import IconX from '@/assets/Icons/IconX';
import { useMessages } from '@/hooks/messages';

interface FilterOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const FilterOverlay = ({ isOpen, onClose, children }: FilterOverlayProps) => {
  const globalMessages = useMessages(GlobalMessages);

  if (!isOpen) return null;

  return (
    <div
      role='presentation' // backdrop dismiss overlay; Escape key closes via onKeyDown
      className='bg-c16/50 fixed inset-0 z-50 flex items-end lg:hidden'
      onClick={onClose}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
    >
      <div
        role='none' // inner panel — stopPropagation only, not an activator
        className='animate-slide-up dark:bg-c16 w-full rounded-t-xl bg-white p-6'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='mb-4 flex items-center justify-between'>
          <h3 className='text-lg font-semibold dark:text-white'>{globalMessages.filter()}</h3>
          <button onClick={onClose} className='dark:hover:bg-c4 rounded-lg p-2 hover:bg-gray-100'>
            <IconX className='h-5 w-5 text-black dark:text-white' />
          </button>
        </div>
        <div className='space-y-4'>{children}</div>
        <div className='dark:border-c4 mt-6 border-t pt-4'>
          <button onClick={onClose} className='bg-c1 w-full rounded-lg py-3 font-medium text-black'>
            {globalMessages.applyFilters()}
          </button>
        </div>
      </div>
    </div>
  );
};
